<template>
  <v-card tile>
    <v-card-title>
      Obvestila
      <v-spacer></v-spacer>
      <v-checkbox
        v-model="showComplete"
        label="Pokaži zaključene"
        @change="updateFilters"
      ></v-checkbox>
    </v-card-title>
    <v-card-text v-if="notifications">
      <v-data-table
        :headers="headers"
        :items="notifications.data"
        :page.sync="notifications.current_page"
        :items-per-page="notifications.per_page"
        :server-items-length="notifications.total"
        :options.sync="tableOptions"
        :footer-props="{
          itemsPerPageOptions: [10, 25, 50],
        }"
        sort-by="id"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-text-field
              v-model="search"
              @change="updateFilters"
              append-icon="mdi-magnify"
              label="Iskalnik"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark class="mb-2" @click="create"
              >Dodaj
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.text`]="{ item }">
          <div @click="openItemDocuments(item)">{{ item.text }}</div>
        </template>
        <template v-slot:[`item.user_id`]="{ item }">
          {{ item.user ? item.user.name : "" }}
        </template>
        <template v-slot:[`item.expires_at`]="{ item }">
          {{
            item.expires_at !== null
              ? $moment(item.expires_at).format("DD.MM.YYYY")
              : null
          }}
        </template>
        <template v-slot:[`item.completed_at`]="{ item }">
          {{
            item.completed_at !== null
              ? $moment(item.completed_at).format("DD.MM.YYYY")
              : null
          }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <TooltipIconButton
            tooltip="Označi kot dokončano"
            icon="mdi-check"
            @click="finalize(item)"
            v-if="item.completed_at === null"
          ></TooltipIconButton>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import TooltipIconButton from "@/components/TooltipIconButton.vue";

export default {
  data: () => ({
    headers: [
      {
        text: "Obvestilo",
        value: "text",
      },
      {
        text: "Datum poteka",
        value: "expires_at",
      },
      {
        text: "Zaključeno",
        value: "completed_at",
      },
      {
        text: "Zaključil",
        value: "user_id",
      },
      { text: "", value: "actions" },
    ],
    notifications: null,
    showComplete: false,
    search: "",
  }),
  mounted() {
    this.showComplete = this.$route.query.showComplete === "true" || false;
    if (this.$route.query.search) {
      this.search = decodeURIComponent(this.$route.query.search);
    }
  },
  methods: {
    loadNotifications() {
      let orderBy = {};
      if (
        this.tableOptions.sortBy.length > 0 &&
        this.tableOptions.sortDesc.length > 0
      ) {
        orderBy[this.tableOptions.sortBy[0]] =
          this.tableOptions.sortDesc[0] === true ? "desc" : "asc";
      }

      let filters = {};
      if (this.$route.query.showComplete !== "true") {
        filters["completed_at"] = null;
      }
      if (this.$route.query.search) {
        filters["text"] = encodeURIComponent("%" + this.search + "%");
      }
      let params = {
        page: this.tableOptions.page,
        perPage: this.tableOptions.itemsPerPage,
        orderBy,
        filters,
      };

      this.$http.get("api/v1/notifications", { params }).then((response) => {
        this.notifications = response.data;
      });
    },
    finalize(item) {
      this.$http
        .put("api/v1/notifications/" + item.id, {
          completed: true,
        })
        .then((response) => {
          item.completed_at = response.data.completed_at;
          item.user_id = response.data.user_id;
          item.user = response.data.user;

          this.$store.dispatch(
            "user/notifications",
            this.$store.getters["user/user"].notifications - 1
          );
        });
    },
    openItemDocuments(notification) {
      switch (notification.type) {
        case "company_document":
          this.$router.push({
            name: "CompanyDocuments",
            params: {
              companyId: notification.item_id,
            },
          });
          break;
        case "employee_document":
          this.$router.push({
            name: "EmployeeDocuments",
            params: {
              employeeId: notification.item_id,
            },
          });
          break;
        case "vehicle_document":
          this.$router.push({
            name: "VehicleDocuments",
            params: {
              vehicleId: notification.item_id,
            },
          });
          break;
      }
    },
    updateFilters() {
      let query = { ...this.$route.query };
      query["page"] = 1;

      delete query["showComplete"];
      if (this.showComplete !== null) {
        query.showComplete = this.showComplete;
      }
      delete query["search"];
      if (this.search) {
        query.search = encodeURIComponent(this.search);
      }

      this.$router
        .replace({
          query,
        })
        .catch(() => {});
      this.loadNotifications();
    },
  },
  computed: {
    tableOptions: {
      get() {
        return {
          page: parseInt(this.$route.query.page) || 1,
          itemsPerPage: parseInt(this.$route.query.perPage) || 10,
          sortBy: this.$route.query.sortBy
            ? [this.$route.query.sortBy]
            : ["created_at"],
          sortDesc: [this.$route.query.sortDesc || "true"],
        };
      },
      set(value) {
        let query = {
          page: value.page,
          perPage: value.itemsPerPage,
        };

        if (this.$route.query.showComplete) {
          query.showComplete = this.$route.query.showComplete;
        }
        if (this.search) {
          query.search = encodeURIComponent(this.search);
        }

        if (value.sortBy.length > 0) {
          query.sortBy = value.sortBy[0];
          query.sortDesc = value.sortDesc[0];
        }
        this.$router
          .replace({
            query,
          })
          .catch(() => {});
      },
    },
  },
  watch: {
    tableOptions: {
      handler(newValue, oldValue) {
        if (JSON.stringify(newValue) === JSON.stringify(oldValue)) {
          return;
        }
        this.loadNotifications();
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    TooltipIconButton,
  },
};
</script>
<style></style>
